<!-- FIXME: All duplicated HTML should by ng-templates and outlet to each image type format. -->
<link href="https://cdn.syncfusion.com/ej2/material.css" rel="stylesheet" /> <!-- TODO: host this CSS in the project? -->


<!-- ... Modals template section ...-->
<ng-template #deleteConfirmModal>
  <p>
    Are you sure you want to delete this image and its associated record?
    <b> This action cannot be undone!</b> <br><br>
    Please confirm below:
  </p>
  <input type="text" class="editable form-control" id="delConfirmTxt" #delConfirmTxt placeholder="Type the word 'delete' if you are sure">
</ng-template>
<ng-template #keystrokeHelpModal>
  <ul>
    <li>Enter Edit Mode........................... Ctrl+E / Cmd ⌘+E</li>
    <li>Save................................................ Ctrl+S / Cmd ⌘+S</li>
    <li>Cancel............................................ Ctrl+Z / Cmd ⌘+Z</li>
    <li>Keyword Entry Field....... Ctrl+K / Cmd ⌘+K</li>
    <li>Navigate to Previous Record.. Ctrl+&larr; / Cmd ⌘+&larr;</li>
    <li>Navigate to Next Record......... Ctrl+&rarr; / Cmd ⌘+&rarr;</li>
    <li>Move To Next Field.................................................. TAB</li>
    <li>Move to Previous Field................................. Shift+TAB</li>
    <li>Toggle Checkboxes, Press Buttons........... SPACEBAR</li>
  </ul>
  <ul>
    <li>Toggle Zoom Mode......................... Ctrl+&uarr; / Cmd ⌘+&uarr;</li>
    <li>Zoom In (when in zoom mode).................... Plus Key(+)</li>
    <li>Zoom Out (when in zoom mode)................ Minus Key(-)</li>
  </ul>
  <p>
    When "tabbing-through" the Table Editors:<br>
    Use ENTER to begin editing a row.<br>
    Then use ENTER again to end your changes to that row.<br>
    Or use ESC to cancel your changes to that row.<br>
  </p>
  <p>
    When using the Keyword Entry feature:<br>
    After typing your keyword, press ENTER to add the keyword<br>
    to the list and then you may immediately continue typing<br>
    keywords. <br>
    You can use the arrow keys to move up and down in the typeahead suggestions.<br>
    If you click off of the field, the keyword will not be added.<br>
  </p>
</ng-template>
<!-- ... End Modals template section ... -->

<ng-template #datesLoading>
  Loading relevant dates…
  <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
</ng-template>
<ng-template #unitsLoading>
  Loading units data…
  <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
</ng-template>
<ng-template #weaponsLoading>
  Loading weapons data…
  <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
</ng-template>
<ng-template #individualsLoading>
  Loading image individuals data…
  <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
</ng-template>
<ng-template #qmsLoading>
  Loading Quartermaster &amp; Ordnance Specifications…
  <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
</ng-template>
<!-- <ng-template #loadingAnim>
  <div class="loader-filters" [ngClass]="{'mobile':isHandset}">
    <div class="loader-filters-inner ball-grid-pulse">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template> -->
<ng-template #battlesDisplayer>
  <app-battle-display [columns]="['Battle']" *ngIf="loaded" [data]="imageData.battleLinks" [isAdmin]="canEdit"></app-battle-display>
</ng-template>
<ng-template #datesDisplayer>
  <app-dates-display [columns]="datesDisplayerColumns" *ngIf="datesData$ | async; else datesLoading"
                     [data]="imageData.relevantDates" [isAdmin]="isAdmin" (handleEndOfData)="datesData$ = getDatesData(imageData.uid, $event)">
  </app-dates-display>
</ng-template>
<ng-template #unitsDisplayer>
  <app-units-display [columns]="['Army', 'Corps', 'Regiment', 'State', 'Branch', 'Company']" *ngIf="unitData$ | async; else unitsLoading" [data]="imageData.units" [isAdmin]="canEdit"></app-units-display>
</ng-template>
<ng-template #weaponsDisplayer>
  <app-weapons-display [columns]="['Weapon Category', 'Weapon']" *ngIf="weaponsData$ | async; else weaponsLoading" [data]="imageData.weapons" [isAdmin]="canEdit"></app-weapons-display>
</ng-template>
<ng-template #qmSpecificationsDisplayer>
  <app-qmmanuals-display (linkClick)="viewQMManual($event)" *ngIf="qmsData$ | async; else qmsLoading" [data]="mapQMLinkArray()" [isAdmin]="canEdit" [editable]="false" [columns]="(canEdit ? ['Item Name', 'Created Date Time', 'Created By'] : ['Item Name'])"></app-qmmanuals-display>
</ng-template>
<ng-template #keywordsDisplayer> <!-- For view and edit modes -->
  <div class="align-items-baseline keywords">
    <app-keywords-display [data]="imageKeywordsMap"
                (changePageEmitter)="navigateToLibrary()" (deleteMeEmitter)="commitKeywordRemoval($event)" [searchText]="librarySearchText" [isAdmin]="(isAdmin || librarian) && editMode"></app-keywords-display>
    <div class="form-row" *ngIf="editMode">
      <label for="keywordInput" class="col-3 fieldName">Tag keywords: </label>
      <app-keyword-search dropDown="true" [selectionMode]="true" allDataDropdown="true" (selectedOutput)="addKeywordToImage($event)" (errorOutput)="qmSearchError($event)"></app-keyword-search>
      
    </div>
  </div>
</ng-template>
<ng-template #locationTypeahead>
  <input type="text" placeholder="Location" name="location" #locationSearcher
              [focusFirst]="false"
              (keydown.Tab)="ignoreTypeaheadSuggestion = true"
              (focus)="locationFocus$.next($any($event).target.value)" (click)="locationClick$.next($any($event).target.value)" (blur)="ignoreTypeaheadSuggestion = false" (keypress)="setFormDirty()"
              (selectItem)="interceptTypeaheadSelection($event)"
               maxlength="200"
              [(ngModel)]="imageData.location" class="editable form-control" id="location"><!--[ngbTypeahead]="broadTypeaheadSearch('location', 'location', locationClick$, locationFocus$, locationSearcher)"-->
</ng-template>
<ng-template #regionTypeahead>
  <input type="text" placeholder="Region" (keydown.Tab)="ignoreTypeaheadSuggestion = true" (blur)="ignoreTypeaheadSuggestion = false" class="editable form-control" (keypress)="setFormDirty()"
  name="regionalName" maxlength="250" [(ngModel)]="imageData.regionalName">
</ng-template>
<ng-template #unitsEdit>
  <div class="form-row align-items-baseline" *ngIf="!newUnitMode">
    <app-slant-button btnColor="gray" class="new-unit-btn" (click)="showUnitBuilder = !showUnitBuilder" [btnIconClass]="showUnitBuilder ? 'fa-times' : 'fa-plus'">{{ showUnitBuilder ? 'Cancel' : 'Add Unit' }}</app-slant-button>
    <app-unit-picker *ngIf="showUnitBuilder" [coLetters]="companyLetters" [regiments]="regiments"
      [states]="statesData" [branches]="branchesOfService" (unitSelected)="addUnitToData($event)">
    </app-unit-picker>
    <br>
    <lib-table-editor *ngIf="unitData$ | async; else unitsLoading" #unitTable class="table-editor" [rpp]='5' [rppOptions]="rppOptions"
      [tableMaxHeight]="tableMaxHeight" [notify]="unitsNotifier" [rpp]="unitRpp" [titlePosition]="'left'"
      [tableTitle]="'Units'" [addDisabled]="true" [tableData]="imageData.units"
      [columnsData]="unitLinksColumnData" [isAdmin]="true" (invalidDataEvent)="badDataEntered()"
      [addDisabled]="true" (cancelNewRowEvent)="removeNewUnitRow($event)"
      (saveChangesEvent)="commitUnitLinkChanges($event)" (deleteDataEvent)="commitUnitLinkRemoval($event)"
      [paginationOn]="true"></lib-table-editor>
  </div>
</ng-template>

<ng-container *ngIf="!isCrawler; else crawlerDisplay">
<div *ngIf="isTrialUser" class="blurScreen"></div>
<div class="container-fluid" #singleImageViewWrapper id="singleImageViewWrapper" tabindex="0" autofocus
  (keydown)="handleKeyboardEvents($event)" [ngStyle]="{'padding-bottom': isHandset ? '10em':'0', 'overflow-x':'hidden', 'overflow-y':'auto', 'overscroll-behavior':'auto'}"
  [ngClass]="{'mobile' : isHandset}">
  <div class="row"  [ngStyle]="{'margin-left': isHandset ? '0px':'', 'margin-right': isHandset ? '0px':''}">
    <div *ngIf="!loaded" class="col-4"></div>
    <div *ngIf="!loaded" class="col-4">
      <br><br>      
      <div [hidden]="errorMessage.toString() != ''" class="loader" [ngClass]="{'loaderMobile' : isHandset}">
        <div class="loader-inner ball-triangle-path">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <div *ngIf="!loaded" class="col-4"></div>
    <div *ngIf="!loaded" class="col-12" style="height: 95vh;">
      <h4>
        {{ errorMessage }}
        <span *ngIf="errorMessage.toString() != ''"><button class="btn btn-link" (click)="ngOnInit()"> Retry?</button></span>
      </h4>
    </div>
    <div class="col-xl-6 col-lg-12 col-md-12">
      <!-- title viewer -->
      <div class="col-auto titleViewer" *ngIf="loaded && !zoomMode">
        <div class="buttons">
          <!-- <button style="margin: 4px 0 0 -20px;" class="button button-left button-bw"
            (click)="navigateToLibrary(imageData)" title="< Navigate back" [routerLink]="['/library']">
            <fa-icon class="icon" [icon]="arrowAltCircleLeft"></fa-icon>
            <span class="slant" style="border-left-color: black;"></span>&nbsp; Back to Gallery
          </button> -->
          <app-slant-button class="backBtn" btnColor="bw" leftMode="true" tooltip="< Navigate back to the gallery screen" aria-label="navigate back" (click)="!this.loadedFromQM ? navigateToLibrary() : navigateToQMSpec()" btnIconClass="fa-arrow-alt-circle-left">&nbsp; Back to {{ !this.loadedFromQM ? 'Gallery' : 'QM Spec'}}</app-slant-button>
          <div *ngIf="!isTrialUser" class="btn-group prev-nextButtons"  style="margin: 4px 0 0 0; float: right;" [ngClass]="{'mobile' : isHandset}">
            <app-slant-button btnColor="red" [chevronMode]="true" [disabled]="!loaded || recordNoInSet <= 1" style="border-right: 1px solid #ccc;" tooltip="Previous record" (click)="goPrevRecord()" btnIconClass="fa-chevron-left" leftMode="true"> Prev Record</app-slant-button>

            <app-slant-button btnColor="blue" [chevronMode]="true" style="border-left: 1px solid #ccc;" tooltip="Next record" (click)="goNextRecord()" [disabled]="!loaded || recordNoInSet === totalRecordsInSet" btnIconClass="fa-chevron-right">Next Record</app-slant-button>
            <div *ngIf="recordNoInSet > 0" class="showing-x-of-y text-muted" [ngClass]="{'mobile' : isHandset}">
              (Showing {{ recordNoInSet }} of {{ totalRecordsInSet }} results)
            </div>
          </div>

        </div>

        <h6 style="width: 100%;">
          <small class="text-muted">Type: </small>
          <span *ngIf="editMode === false">{{ imageData.typeOfImage.typeOfImage }}</span>
          <div class="typeOfImageDropdown" *ngIf="editMode === true && loaded === true">
            <div class="col">
              <select (ngModelChange)="handleChangeImageType($event)" class="form-control typeOfImageDropdown" name="imageType" [ngModel]="imageData.typeOfImageId" (ngModel)="imageData.typeOfImage"
              #imageTypeDropdown id="imageType">
                <option [ngValue]="null" disabled>Choose an image type</option>
                <option [ngValue]="a.uid" *ngFor="let a of allImageTypes" [selected]="a.uid == imageData.typeOfImageId">
                  {{ a.typeOfImage }}
                </option>
              </select>
            </div>
          </div>
          <small *ngIf="imageData.boundImageSets?.length" class="text-muted ms-3">Set: </small>
          <span *ngIf="imageData.boundImageSets?.length">{{ imageData.boundImageSets?.length ? imageData.boundImageSets[0].name : '' }}</span>
        </h6>
        <h2 style="display: inline-block;">
          <span style="font-size: 1.1em;" [innerHtml]="imageData.name | imageName : imageData.orderNo | embolden : librarySearchText : 0 : searchHighlightStyle"></span>
        </h2>
        <br *ngIf="!imageData.fullyTagged" />
        <h5 *ngIf="!imageData.fullyTagged" class="researchNotif" style="display: inline-block;">
          <i class="fal fa-info-circle"></i>
          <span class="researchNotifText">Our librarians are currently researching this record</span>
        </h5>
      </div>

      <div *ngIf="(isInLedgerMode && loaded && !zoomMode)" class="ledger-navigation-bar">

        <!-- Navigation controls -->
        <div class="navigation-controls">
          <!-- Previous button -->
          <app-slant-button 
          *ngIf="!isHandset"
            btnColor="blue" 
            (click)="navigatePreviousInLedger()" 
            [disabled]="isLoadingLedgerData"
            [tooltip]="'Previous page in ' + currentLedger?.name"
            btnIconClass="fa-chevron-left">
            Previous
          </app-slant-button>

          <!-- Page number input -->
          <div class="sequence-navigation-wrapper">
            <div class="sequence-input-group">
              <label class="me-2">Page:</label>
              
                <input type="number" 
                      [formControl]="sequenceNumberInput" 
                      class="form-control form-control-sm sequence-input" 
                      [min]="1" 
                      [max]="totalLedgerImages"
                      [disabled]="isLoadingLedgerData"
                      [placeholder]="isLoadingLedgerData ? 'Loading...' : currentSequenceNumber.toString()">
                <span class="ms-2">of {{ totalLedgerImages || '...' }}</span>
              </div>

          </div>

          <!-- Next button -->
          <app-slant-button 
          *ngIf="!isHandset"
            btnColor="blue" 
            (click)="navigateNextInLedger()" 
            [disabled]="isLoadingLedgerData"
            [tooltip]="'Next page in ' + currentLedger?.name"
            btnIconClass="fa-chevron-right">
            Next
          </app-slant-button>
        </div>

      </div>

      <!-- Image viewer -->
      <div *ngIf="loaded && !zoomMode" class="imageViewer imageViewer-xl imageViewer-md" style="margin-bottom: 3em;" [ngClass]="{'mobile': isHandset}">
        <button [hidden]="zoomMode" id="zoomBtn" class="btn btn-light" matTooltip="Enter zoom mode" [matTooltipPosition]="'right'"
          (click)="fullScreenImage()">
          <i class="fal fa-expand"></i>
        </button>
        
        <div *ngIf="loaded" class="mainImg" #mainImg [ngClass]="{'mobile': isHandset}" (dblclick)="fullScreenImage()"
          [ngStyle]="{'background-image': 'url(' + imageData?.filePath + ')', 'height': boundImageCarouselArray.length ? 'calc(100vh * (0.72))' : 'calc(100vh * (0.8))', 'transform':getImageTransform()}" 
          [title]="imageData?.name | imageName : imageData?.orderNo">
        </div>
        <div class="imageCarouselContainerBelowImage"style="padding-bottom: 6%;">
          <app-image-carousel #imageCarousel *ngIf="imageModels && imageModels.length > 0 && !isInLedgerMode"
            [imageModels]="imageModels"
            [noImageMSG]="''"
            [selectedImage]="imageData"
            [showButtonsInsteadOfCarousel]="isHandset"
            [isBoundImageSet]=true
            (recordSelected)="goToImage($event)"
            (handleEndOfImageSet)="getBoundImageSetNextPage()"></app-image-carousel>

            <app-image-carousel 
              *ngIf="isInLedgerMode && ledgerImages.length > 0"
              #ledgerCarousel
              [imageModels]="ledgerImages"
              [selectedImage]="imageData"
              [carouselSize]="35"
              [isLedgerSet]=true
              [showButtonsInsteadOfCarousel]="isHandset"
              (recordSelected)="handleLedgerCarouselSelection($event)"
              (handleEndOfImageSet)="loadMoreLedgerImages()"
              [noImageMSG]="'No images in this ledger'">
          </app-image-carousel>
        </div>
      </div>
    </div>

    <!-- ....ZOOM MODE MECHANISM.... -->
    <div *ngIf="zoomMode" class="zoomControlsHolder btn-toolbar" role="toolbar" aria-label="Zoom controls toolbar" (keydown)="handleKeyboardEvents($event)">
      
      <!-- Desktop view: All controls in one row -->
      <div *ngIf="!isHandset" class="btn-group" style="background-color: #343a40;" role="group" aria-label="all controls group">
        <!-- Zoom controls -->
        <button id="zoomOutBtn" class="zoom-out btn btn-dark" matTooltip="Zoom -" #zoomOutBtn>
          <i class="fal fa-search-minus"></i>
        </button>
        <div style="display: inline-flex; align-items: center; padding: 8px; background-color: #343a40;">
          <label for="desktopZoomSlider" class="text-white small mb-0 me-2" style="min-width: 45px; text-align: center;">{{(currentZoomLevel | number:'1.0-2')}}x</label>
          <input type="range" class="custom-range" matTooltip="Slide to change zoom level" id="desktopZoomSlider" min="0.33" max="10" [value]="currentZoomLevel"step="0.2" #zoomRange style="width: 120px;" (input)="currentZoomLevel = +$event.target.value"/>
        </div>
        <button id="zoomInBtn" class="zoom-in btn btn-dark" matTooltip="Zoom +" #zoomInBtn>
          <i class="fal fa-search-plus"></i>
        </button>
        
        <!-- Rotation controls -->
        <button class="btn btn-dark" matTooltip="Rotate right 15°" (click)="rotateImage(15)">
          <i class="fal fa-redo"></i>
        </button>
        <div style="display: inline-flex; align-items: center; padding: 8px; background-color: #343a40;">
          <label for="desktopRotationSlider" class="text-white small mb-0 me-2" style="min-width: 45px; text-align: center;">{{rotationAngle}}°</label>
          <input type="range" class="form-range" id="desktopRotationSlider"min="0" max="360" step="1" [value]="rotationAngle"(input)="rotationAngle=+$event.target.value" style="width: 120px;" matTooltip="Adjust rotation angle">
        </div>
        <button class="btn btn-dark" matTooltip="Rotate left 15°" (click)="rotateImage(-15)">
          <i class="fal fa-undo"></i>
        </button>
        
        <!-- Mirror controls -->
        <button class="btn btn-dark" [class.active]="isFlippedHorizontally" matTooltip="Mirror horizontally" (click)="toggleHorizontalFlip()">
          <img src="assets/icons/mirror-horizontal.svg" alt="Mirror horizontally" style="width: 16px; height: 16px; filter: brightness(0) invert(1);">
        </button>
        <button class="btn btn-dark" [class.active]="isFlippedVertically" matTooltip="Mirror vertically" (click)="toggleVerticalFlip()">
          <img src="assets/icons/mirror-vertical.svg" alt="Mirror vertically" style="width: 16px; height: 16px; filter: brightness(0) invert(1);">
        </button>
        
        <!-- Reset and exit -->
        <button class="btn btn-dark" id="zoomResetBtn" matTooltip="Reset" #zoomResetBtn>
          <i class="fal fa-dot-circle"></i>
        </button>
        <button class="btn btn-dark" matTooltip="Exit zoom mode" (click)="exitZoom()">
          <i class="fal fa-times"></i>
        </button>
      </div>
      
      <!-- Mobile view: Two rows -->
      <div *ngIf="isHandset" class="d-flex flex-column w-100">
        <!-- First row: Zoom controls, reset, close -->
        <div class="btn-group mb-2" style="background-color: #343a40;" role="group" aria-label="zoom controls">
          <button id="zoomOutBtn" class="zoom-out btn btn-dark" matTooltip="Zoom -" #zoomOutBtn>
            <i class="fal fa-search-minus"></i>
          </button>
          <div style="display: inline-flex; align-items: center; padding: 8px; background-color: #343a40; flex: 1;">
            <label for="mobileZoomSlider" class="text-white small mb-0 me-2" style="min-width: 45px; text-align: center;">{{(currentZoomLevel | number:'1.0-2')}}x</label>
            <input type="range" class="custom-range" matTooltip="Slide to change zoom level" id="mobileZoomSlider" min="0.33" max="10" [value]="currentZoomLevel"
              step="0.2" #zoomRange style="width: 100%;" (input)="currentZoomLevel = +$event.target.value" />
          </div>
          <button id="zoomInBtn" class="zoom-in btn btn-dark" matTooltip="Zoom +" #zoomInBtn>
            <i class="fal fa-search-plus"></i>
          </button>
          <button class="btn btn-dark" id="zoomResetBtn" matTooltip="Reset" #zoomResetBtn>
            <i class="fal fa-dot-circle"></i>
          </button>
          <button class="btn btn-dark" matTooltip="Exit zoom mode" (click)="exitZoom()">
            <i class="fal fa-times"></i>
          </button>
        </div>
        
        <!-- Second row: Transform controls -->
        <div class="btn-group" style="background-color: #343a40;" role="group" aria-label="transform controls">
          <button class="btn btn-dark" matTooltip="Rotate right 15°" (click)="rotateImage(15)">
            <i class="fal fa-redo"></i>
          </button>
          <div style="display: inline-flex; align-items: center; padding: 8px; background-color: #343a40; flex: 1;">
            <label for="mobileRotationSlider" class="text-white small mb-0 me-2" style="min-width: 45px; text-align: center;">{{rotationAngle}}°</label>
            <input type="range" class="custom-range" id="mobileRotationSlider" min="0" max="360" step="1" [value]="rotationAngle" (input)="rotationAngle=+$event.target.value" style="width: 100%;" matTooltip="Adjust rotation angle">
          </div>
          <button class="btn btn-dark" matTooltip="Rotate left 15°" (click)="rotateImage(-15)">
            <i class="fal fa-undo"></i>
          </button>
          <button class="btn btn-dark" [class.active]="isFlippedHorizontally" matTooltip="Mirror horizontally" (click)="toggleHorizontalFlip()">
            <img src="assets/icons/mirror-horizontal.svg" alt="Mirror horizontally" style="width: 16px; height: 16px; filter: brightness(0) invert(1);">
          </button>
          <button class="btn btn-dark" [class.active]="isFlippedVertically" matTooltip="Mirror vertically" (click)="toggleVerticalFlip()">
            <img src="assets/icons/mirror-vertical.svg" alt="Mirror vertically" style="width: 16px; height: 16px; filter: brightness(0) invert(1);">
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="zoomMode" class="zoomHolder">
      <div id="panZoomDiv" #panZoomDiv>
        <img id="zoomTargetImage" #zoomedImg (error)="zoomedImg.src = '../../assets/ra-logo.png'; errorImageSpoof();" [src]="imageData?.filePath"[style.transform]="getImageTransform()">
      </div>
    </div>
    <!-- ....END ZOOM MODE MECHANISM.... -->

    <ng-template #rotateThumbnail>
      <div style="margin: auto; display:block; width:fit-content;">
        <app-thumbnail [dtsSelectItem]="imageData" [@thumbnailFade]="'in'" [id]="'thumbnail' + imageData.uid"
        [imageData]="imageData">
        </app-thumbnail>
      </div>
      <br>
      <p class="mt-1">
       The updated thumbnail has been saved.
      </p>
    </ng-template>

    <div *ngIf="loaded" class="col-xl-6 col-lg-12 col-md-12 dataViewer" [hidden]="zoomMode ? true : false">
      <div *ngIf="!editMode">
        <app-slant-button btnColor="gray" [ngStyle]="{'margin-left': isHandset ?  '0' : '-15px;'}"  *ngIf="(isAdmin || loggedInUser.isInUserGroup('Librarian')) && !isHandset" (click)="startEditMode()" btnIconClass="fa-pencil">Edit Record&nbsp;</app-slant-button>
        <app-slant-button btnColor="gray" *ngIf="(isAdmin || loggedInUser.isInUserGroup('Librarian')) && !isHandset" tooltip="New thumbnail with the correct orientation for this record." (click)="startThumbnailEditMode()" btnIconClass="fad fa-redo" [disabled]="isGeneratingThumbnail">Regenerate Thumbnail&nbsp;</app-slant-button>
        <app-slant-button btnColor="gray" *ngIf="!imageData.checkedOut && !imageData.fullyTagged" (click)="requestTranscription()" btnIconClass="fad fa-file-alt">Request Transcription&nbsp;</app-slant-button>

        <hr style="margin: 42px 0 3px -15px;">

        <div *ngIf="imageData.source && imageData.source.source !== 'Unknown/Public Domain'" style="margin-top: 15px;" [ngClass]="isHandset ? 'sourcePlateMobileContainer' : ''">
          
          <dl class="row first sourcePlate" [ngClass]="{'mobile': isHandset}" style="line-height: 50px; width: auto;">
            <dt style="width: auto;">This image is provided by </dt>
            <dd style="width: auto;">
              <a *ngIf="imageData.source.homePageUrl" [href]="imageData.source.homePageUrl" target="_blank" rel="noreferrer noopener" title="Click to visit their homepage" style="width: auto;">{{ imageData.source.source }}</a>
              <span *ngIf="!imageData.source.homePageUrl">{{ imageData.source.source }}</span>
            </dd>
            <img *ngIf="imageData.source.logoPath" [src]="imageData.source.logoPath" style="width: auto;"/>
          </dl>

          <dl class="row first sourcePlate" *ngIf="currentLedger">
            <dt style="width: auto;">Part of Ledger:</dt>
            <dd style="width: auto;">
              <a href="javascript:void(0)" 
                (click)="navigateToLedgerInLibrary()" 
                class="ledger-link"
                [matTooltip]="'Click to view all ' + totalLedgerImages + ' pages in this ledger'">
                <i class="fas fa-book-open me-1"></i>
                {{ currentLedger.name }}
              </a>
            </dd>
          </dl>
        </div>

        <div *ngIf="this.imageData.typeOfImageId !== ImageTypes.Ordnance_Returns">
          <dl class="row" [ngClass]="{'mobile': isHandset}"*ngIf="this.imageData.typeOfImageId === ImageTypes.General_Special_Orders">
            <dt>Date Issued </dt>            <dd>
              <ng-container *ngTemplateOutlet="datesDisplayer"></ng-container>
            </dd>
          </dl>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Location</span>
              <span class="field-value">{{ imageData.location }}</span>
            </div>
            <div class="col-auto">
              <span class="field-label">Location State</span>
              <span class="field-value">{{ imageData.locationState?.state_Name }}</span>
            </div>          </div>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Region</span>
              <span class="field-value">{{ imageData.regionalName }}</span>
            </div>
          </div>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">{{ imageData.typeOfImageId !== ImageTypes['Letters & Diaries'] ? 'Battle' : 'Battles' }}</span>
              <span class="field-value">
                <ng-container *ngTemplateOutlet="battlesDisplayer"></ng-container>
              </span>
            </div>          </div>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}"> 
            <div class="col-auto">
              <span class="field-label">Army</span>
              <span class="field-value">{{ imageData.army?.fullName() }}</span>
            </div>
          </div>

          <div class="rtf-ineditable row" *ngIf="imageData.typeOfImageId !== ImageTypes.Photos"
          [ngStyle]="{'margin-left': isHandset ? '0px':'', 'margin-right': isHandset ? '-30px':''}" >
            <div libDraggable [dragHandle]="'.rtf-title-ineditable'" [dragTarget]="'.rtf-ineditable'" class="card transcription">
              <div class="rtf-container">
                <div class="drag-box-ineditable">
                  <div class="rtf-title-ineditable">
                    <i class="far fa-grip-vertical fa-sm me-1" title="You can drag me"></i>
                    Letter Transcription: 
                  </div>
                </div>
              </div>
              <ejs-richtexteditor [id]="'alltoolRTE'" (actionComplete)="handleRTFActions($event)" [height]="RTFHeight" [readonly]="true" [enableHtmlEncode]="true"
                [enablePersistence]="false" [value]="imageData.transcription" #toolsRTE id="alltoolRTE"
                ></ejs-richtexteditor>
            </div>
          </div>
          <dl class="row" [ngClass]="{'mobile': isHandset}">
            <dt>Notes </dt>
            <dd class="notesDisplay" [innerHtml]="imageData.notes | embolden : librarySearchText: 0 : searchHighlightStyle"></dd>
          </dl>
          <dl class="row" [ngClass]="{'mobile': isHandset}" *ngIf="imageData?.typeOfImageId === ImageTypes.Photos">
            <dt class="fieldName">Mounted </dt>
            <dd>{{ (imageData.mounted) ? 'Yes' : 'No' }}</dd>
          </dl>
          <dl class="row" *ngIf="imageData?.typeOfImageId === ImageTypes.Photos" [ngClass]="{'mobile': isHandset}">
            <dt class="fieldName">Portrait or Field </dt>
            <dd>{{ (imageData.portrait_Field || '--') | titlecase }}</dd>
          </dl>          
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Keywords</span>
              <span class="field-value">
                <ng-container *ngTemplateOutlet="keywordsDisplayer"></ng-container>
              </span>
            </div>
          </div>
          <div class="row location-row" *ngIf="this.imageData.typeOfImageId !== ImageTypes.General_Special_Orders" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Dates</span>
              <span class="field-value">
                <ng-container *ngTemplateOutlet="datesDisplayer"></ng-container>
              </span>
            </div>
          </div>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto" *ngIf="!isHandset">
              <span class="field-label">Units</span>
              <span class="field-value">
                <ng-container *ngTemplateOutlet="unitsDisplayer"></ng-container>
              </span>
            </div>
          </div>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Weapons</span>
              <span class="field-value">
                <ng-container *ngTemplateOutlet="weaponsDisplayer"></ng-container>
              </span>
            </div>
          </div>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Contract Items</span>
              <span class="field-value">
                <ng-container *ngTemplateOutlet="qmSpecificationsDisplayer"></ng-container>
              </span>
            </div>
          </div>
          <dl class="row" *ngIf="imageData.typeOfImageId !== ImageTypes.Ordnance_Returns" [ngClass]="{'mobile': isHandset}">
            <dt>Individuals </dt>
            <dd [ngClass]="{'mobile': isHandset}">
              <app-individuals-display #individualDisplayComponent *ngIf="(individualsData$ | async) || (imageData && imageData.imageIndividuals?.length > 0); else individualsLoading" 
                [columns]="['Name','Rank', (imageData.typeOfImageId === ImageTypes['Letters & Diaries'] || imageData.typeOfImageId === ImageTypes.Unspecified) ? 'Author' : 'Rank in Photo', 'Regiment','State','Branch','Company','Notes']" [isAdmin]="isAdmin"
                [editable]="false" [data]="imageData.imageIndividuals" [totalRecords]="totalIndividualRecords" [typeOfImageId]="imageData.typeOfImageId" [searchText]="librarySearchText" (handleEndOfData)="individualsData$ = getIndividualsData(imageData.uid, $event)">
              </app-individuals-display>
            </dd>
          </dl>
        </div>

        <div class="ordReturn" *ngIf="this.imageData.typeOfImageId === ImageTypes.Ordnance_Returns">
          <dl class="row" [ngClass]="{'mobile': isHandset}">
            <dt>Notes </dt>
            <dd class="notesDisplay" [innerHtml]="imageData.notes | embolden : librarySearchText: 0 : searchHighlightStyle"></dd>
          </dl>
          <dl class="row" [ngClass]="{'mobile': isHandset}">
            <dt>Units </dt>
            <dd>
              <ng-container *ngTemplateOutlet="unitsDisplayer"></ng-container>
            </dd>
          </dl>
          <dl class="row" [ngClass]="{'mobile': isHandset}">
            <dt>Dates </dt>
            <dd>
              <ng-container *ngTemplateOutlet="datesDisplayer"></ng-container>
            </dd>
          </dl>
          <dl class="row" [ngClass]="{'mobile': isHandset}">
            <dt>Army </dt>            <!-- /* cSpell:disable */ -->
            <dd>{{ imageData.army?.fullName() }} </dd>
          </dl>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Location</span>
              <span class="field-value">{{ imageData.location }}</span>
            </div>
            <div class="col-auto">
              <span class="field-label">Location State</span>
              <span class="field-value">{{ imageData.locationState?.state_Name }}</span>
            </div>          
          </div>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Region</span>
              <span class="field-value">{{ imageData.regionalName }}</span>
            </div>
          </div>          
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Keywords</span>
              <span class="field-value">
                <ng-container *ngTemplateOutlet="keywordsDisplayer"></ng-container>
              </span>
            </div>
          </div>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Weapons</span>
              <span class="field-value">
                <ng-container *ngTemplateOutlet="weaponsDisplayer"></ng-container>
              </span>
            </div>
          </div>
          <div class="row location-row" [ngClass]="{'mobile': isHandset}">
            <div class="col-auto">
              <span class="field-label">Contract items in this image</span>
              <span class="field-value">
                <ng-container *ngTemplateOutlet="qmSpecificationsDisplayer"></ng-container>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- ....BEGIN EDIT MODE AREA.... -->

      <form *ngIf="editMode" #imageForm="ngForm" autocomplete="off">
        <div class="editButtonsBar" [ngClass]="rtfFullscreen ? 'fullscreen-button-bar' : ''">
          <div *ngIf="canEdit" class="btn-group" role="group" aria-label="Save Controls">

            <app-slant-button btnColor="green" (click)="submitChanges()" tooltip="Save changes" [disabled]="!imageForm.form.valid || imageForm.pristine || saveInProgress" btnIconClass="fa-save">{{ saveInProgress ? 'Please wait...' : 'Save' }}</app-slant-button>

            <app-slant-button btnColor="yellow" (click)="cancelChanges()" tooltip="Cancel changes" [disabled]="imageForm.pristine || saveInProgress" *ngIf="!imageForm.pristine" btnIconClass="fa-undo">Cancel</app-slant-button>
            <app-slant-button btnColor="yellow" (click)="editMode = false; applySearchHighlight();" tooltip="Cancel edit mode" *ngIf="imageForm.pristine" [disabled]="saveInProgress" btnIconClass="fa-times">Cancel</app-slant-button>

            <app-slant-button btnColor="red" *ngIf="isAdmin" [disabled]="saveInProgress" tooltip="Delete record and image" (click)="deleteImageRecord()" btnIconClass="fa-trash">Delete</app-slant-button>
          </div>
          <div class="right-content" [ngClass]="rtfFullscreen ? 'right-content-fullscreen' : ''">
            <br>
            <input type="checkbox" id="stayInEditModeCheckbox" [ngModelOptions]="{standalone: true}" name="stayInEditMode" disabled
              id="stayInEditMode" [(ngModel)]="stayInEditMode"
              style="vertical-align: middle; width: 1em; height: 2em;"><label for="stayInEditMode" class="disabled">: Persistent Edit
              Mode</label> <button type="button" class="btn btn-link" (click)="openKeyHelpModal()">
                Keyboard Shortcuts
                <i class="fal fa-question-circle"></i>
              </button>
            <hr style="margin: 0 0 1px 0;">
          </div>
        </div>

        <div *ngIf="imageData.typeOfImageId !== ImageTypes.Ordnance_Returns" class="editSection">
          <div class="form-row align-items-baseline" *ngIf="imageData.typeOfImageId === ImageTypes.General_Special_Orders">
            <div class="col-1">
              <label class="fieldName" for="orderNo">Order #: </label>
            </div>
            <div class="col">
              <input type="number" #orderNoField autofocus class="editable form-control" placeholder="Order #" id="orderNoField" (keypress)="setFormDirty()"
                [(ngModel)]="imageData.orderNo" maxlength="100" name="orderNo" #orderNo="ngModel" required>
              <div *ngIf="!orderNo.valid && !orderNo.pristine" style="width: 96%;" class="alert alert-danger">Order # is required</div>
            </div>
          </div>

          <div class="form-row align-items-baseline" [ngClass]="!isHandset? 'd-flex': ''">
            <div class="col-1">
              <label class="fieldName" for="name">Name: </label>
            </div>
            <div class="col">
              <input type="text" #nameField autofocus class="editable form-control" placeholder="Name" id="nameField"
                [(ngModel)]="imageData.name" maxlength="100" name="name" #name="ngModel" required>
              <div *ngIf="!name.valid && !name.pristine" class="alert alert-danger">Name is required</div>
            </div>
          </div>

          <div class="form-row form-inline align-items-baseline" [ngClass]="!isHandset? 'd-flex': ''" *ngIf="this.imageData.typeOfImageId === ImageTypes.General_Special_Orders">
            <lib-table-editor class="table-editor" [rppOptions]="rppOptions" [notify]="datesNotifier"
              [tableMaxHeight]="tableMaxHeight" [rpp]="5" [titlePosition]="'left'" [cancelNewRow]="true"
              [tableTitle]="'Date Issued'" [tableData]="datesTableRows" [columnsData]="datesColumnData" [isAdmin]="canEdit"
              (deleteDataEvent)="commitDateRemoval($event)" (cancelNewRowEvent)="removeNewDateRow($event)"
              (saveChangesEvent)="commitDateChanges($event)" [paginationOn]="true"></lib-table-editor>
          </div>

          <div class="form-row align-items-baseline" [ngClass]="!isHandset? 'd-flex': ''">
            <div class="col-lg-1 col-md-2 me-2"><label class="fieldName" for="location">Location: </label></div>
            <div class="col-auto">
              <ng-container *ngTemplateOutlet="locationTypeahead"></ng-container>
            </div>
            <div class="col-lg-2 col-md-2"><label class="fieldName" for="locationState">Location State: </label></div>
            <div class="col-auto">
              <select name="locationState" class="form-control" style="width: 180px;" id="locationState"
                (change)="changeLocationState($event.target.value)" [(ngModel)]="imageData.locationStateId">
                <option [ngValue]="">No state chosen</option>
                <option *ngFor="let s of statesData" [value]="s.uid">{{ s.state_Name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row align-items-baseline" [ngClass]="!isHandset? 'd-flex': ''">
            <div class="col-lg-1 col-md-2"><label class="fieldName" for="regionalName">Region: </label></div>
            <div class="col">
              <ng-container *ngTemplateOutlet="regionTypeahead"></ng-container>
            </div>
          </div>
          <div class="form-row align-items-baseline" [ngClass]="!isHandset? 'd-flex': ''">
            <div class="col-lg-1 col-md-2"><label class="fieldName" for="regionalName">Old Battle: </label></div>
            <div class="col">
              <span style="font-size: 1.25em;">{{ imageData.battle }}</span>
            </div>
          </div>
          <div class='form-row' [ngClass]="!isHandset? 'd-flex': ''">
            <h3 style="font-size: 1rem; color: #777;">
              {{this.imageData.typeOfImageId !== ImageTypes['Letters & Diaries'] ? 'Battle:' : 'Battles:'}}
            </h3>
          </div>
          <div class='form-row' style='margin-top: -25px;' [ngClass]="!isHandset? 'd-flex': ''">
            <div style='width:100%; height: 35px; margin-bottom: 15px; display: block;'>
               <app-battle-search #battleSearch configIcon="fa-ellipsis-v" maxResults="10" (selectedOutput)="addBattleToImageFile($event)" allDataDropdown="true" dropDown="true" (errorOutput)="battleSearchError($event)"></app-battle-search>
            </div>
          </div>
          <div class='form-row' style='margin-top: -40px;' [ngClass]="!isHandset? 'd-flex': ''">
            <app-battle-display style="width: 100%;" [columns]="['Battle']" *ngIf="loaded" [data]="imageData.battleLinks" [editable]="canEdit" [isAdmin]="canEdit" (removeAction)="removeBattleLink($event)"></app-battle-display>
          </div>
          <div class="form-row align-items-baseline" *ngIf="!newArmyMode" [ngClass]="!isHandset? 'd-flex': ''">
            <div class="col-lg-1 col-md-2"><label class="fieldName" for="army">Army: </label></div>
            <div class="col">
              <select class="editable form-control" name="army" id="army" (change)="checkNullArmy($event.target.value)"
                [(ngModel)]="imageData.armyId">
                <option [value]=null>No army selected</option>
                <option [value]="-1" style="font-weight: bold">+ Create New Regional Army</option>
                <option *ngFor="let a of armyData" [value]="a.uid">
                  {{ a.army?.armyName }} &ndash; {{ a.regionalName }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-row align-items-baseline" *ngIf="newArmyMode" [ngClass]="!isHandset? 'd-flex': ''">
            <lib-table-editor class="table-editor newEntityTableEditor" [newEntityMode]="true"
              [tableData]="newArmyRowData" [tableTitle]="'Create New Regional Army'" [columnsData]="armyColumnData"
              [isAdmin]="true" (cancelNewEntityEvent)="newArmyMode = false" (saveChangesEvent)="commitNewArmy($event)">
            </lib-table-editor>
          </div>

          <div class="rtf" *ngIf="imageData.typeOfImageId !== ImageTypes.Photos && imageData.typeOfImageId !== ImageTypes.Ordnance_Returns" (click)="handleRTFChanges()" >
            <div libDraggable [dragHandle]="'.drag-box-editable'" [dragTarget]="'.rtf'" class="card">
              <div class="rtf-container-editable">
                <div class="drag-box-editable">
                  <div class="rtf-title">Letter Transcription: </div>
                </div>
              </div>
              <ejs-richtexteditor (created)="rtfCreated()" (actionBegin)="handleRTFChanges($event)" [height]="RTFHeight" [enableHtmlEncode]="true"
                [enablePersistence]="false" [(value)]="imageData.transcription" #toolsRTE id="alltoolRTE"
                [toolbarSettings]="tools" [fontSize]="size" [fontFamily]="fontFamilies" [locale]="'en-US'"></ejs-richtexteditor>
            </div>
          </div>
          <div class="form-row align-items-baseline" [ngClass]="!isHandset? 'd-flex': ''">
            <div class="col-1"><label class="fieldName" for="notes">Notes: </label></div>
            <div class="col"><textarea type="text" placeholder="Notes" class="editable form-control" id="notes" name="notes"
                [(ngModel)]="imageData.notes"></textarea></div>
          </div>
          <div class="form-row align-items-baseline" [ngClass]="!isHandset? 'd-flex': ''">
            <div class="col-lg-1 col-md-2"><label class="fieldName" for="source">Source: </label></div>
            <div class="col">
              <select class="form-control" name="source" id="source" (change)="checkNullSource($event.target.value)"
                [(ngModel)]="imageData.sourceId">
                <option [value]="null">No source selected</option>
                <option [value]="-1" style="font-weight: bold">+ Create New Source</option>
                <option *ngFor="let a of luSources" [value]="a.uid">
                  {{ a.source }}
                </option>
              </select>
            </div>
            &ndash;
            <div class="col">
              <input type="text" id="callNo" placeholder="Call #" name="callNo" maxlength="750"
                class="editable form-control" [(ngModel)]="imageData.callNo">
              </div>
          </div>
          <div class="form-row align-items-baseline" *ngIf="newSourceMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [newEntityMode]="true"
              [tableData]="newLUSourceTableRows" [tableTitle]="'Create New Source Entry'" [columnsData]="luSourceData"
              [isAdmin]="true" (cancelNewEntityEvent)="newSourceMode = false"
              (saveChangesEvent)="commitNewSource($event)"></lib-table-editor>
          </div>
          <div *ngIf="imageData.typeOfImageId === ImageTypes.Photos"
            class="form-row align-items-baseline form-row-checkboxes" [ngClass]="!isHandset? 'd-flex': ''">
            <div class="custom-control custom-checkbox me-2">
              <input type="checkbox" [(ngModel)]="imageData.mounted" class="custom-control-input" name="mounted"
                id="mounted">
              <label for="mounted" style="vertical-align: baseline;" class="custom-control-label">Mounted</label>
            </div>&nbsp; | &nbsp;
            <div *ngIf="imageData.typeOfImageId === ImageTypes.Photos"
              class="custom-control custom-control-inline custom-radio ms-2 me-2">
              <input type="radio" [checked]="imageData.portrait_Field?.toString() === 'portrait'"
                (change)="togglePortrait('portrait')" (click)="setFormDirty()" class="custom-control-input"
                name="portraitfield" id="portrait">
              <label for="portrait" class="custom-control-label">Portrait</label>
            </div>
            <div *ngIf="imageData.typeOfImageId === ImageTypes.Photos"
              class="custom-control custom-control-inline custom-radio ms-2">
              <input type="radio" [checked]="imageData.portrait_Field?.toString() === 'field'" (change)="togglePortrait('field')"
                (click)="setFormDirty()" class="custom-control-input" name="portraitfield" id="field">
              <label for="field" class="custom-control-label">Field</label>
            </div>
          </div>

          <div class="form-row align-items-baseline form-row-checkboxes" [ngClass]="!isHandset? 'd-flex': ''">
            <div class="custom-control custom-checkbox-me-2">
              <input type="checkbox" name="featured" [(ngModel)]="imageData.featured" class="custom-control-input"
                id="featured">
              <label for="featured" class="custom-control-label fieldName">
                Featured
                <i class="fal fa-star ms-1" *ngIf="imageData.featured"></i>
              </label>
            </div>
          </div>
          <hr>
          <label class="fieldName" style="font-size: 1rem;">Keywords: </label>
          <ng-container *ngTemplateOutlet="keywordsDisplayer"></ng-container>
          
          <div class="form-row form-inline align-items-baseline" *ngIf="this.imageData.typeOfImageId !== ImageTypes.General_Special_Orders">
            <label class="text-muted">
              <i class="fal fa-info-circle text-info me-1"></i>
              Only the first date will be shown on the thumbnail.
            </label>
            <lib-table-editor class="table-editor" [rppOptions]="rppOptions" [notify]="datesNotifier"
              [tableMaxHeight]="tableMaxHeight" [rpp]="5" [titlePosition]="'left'" [cancelNewRow]="true"
              [tableTitle]="'Dates'" [tableData]="datesTableRows" [columnsData]="datesColumnData" [isAdmin]="canEdit"
              (deleteDataEvent)="commitDateRemoval($event)" (cancelNewRowEvent)="removeNewDateRow($event)"
              (saveChangesEvent)="commitDateChanges($event)" [paginationOn]="true"></lib-table-editor>
          </div>
          <div class="form-row align-items-baseline" *ngIf="newBranchMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [tableTitle]="'Create New Branch'"
              [tableData]="branchTableRows" [newEntityMode]="true" [titlePosition]="'left'"
              [columnsData]="branchColumnData" [isAdmin]="canEdit" (invalidDataEvent)="badDataEntered()"
              (saveChangesEvent)="commitNewBranch($event)"
              (cancelNewEntityEvent)="newBranchMode = false; newUnitMode = false;"></lib-table-editor>
          </div>
          <div class="form-row align-items-baseline" *ngIf="newRegimentMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [tableTitle]="'Create New Regiment'"
              [tableData]="regimentTableRows" [newEntityMode]="true" [titlePosition]="'left'"
              [columnsData]="regimentColumnData" [isAdmin]="canEdit" (invalidDataEvent)="badDataEntered()"
              (saveChangesEvent)="commitNewRegiment($event)"
              (cancelNewEntityEvent)="newRegimentMode = false; newUnitMode = false;"></lib-table-editor>
          </div>
          <ng-container *ngTemplateOutlet="unitsEdit"></ng-container>
          <div class="form-row align-items-baseline" *ngIf="newWeaponCatMode" [hidden]="newWeaponMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [tableTitle]="'Create New Weapon Category'"
              [titlePosition]="'left'" [newEntityMode]="true" [tableData]="primaryWeaponsTableRows"
              [columnsData]="primaryWeaponsColumnData" [isAdmin]="true" (editDataEvent)="handleTableEditorOnChange($event)"
              (cancelNewEntityEvent)="newWeaponCatMode = false;" (saveChangesEvent)="commitNewWeaponCat($event)">
            </lib-table-editor>
          </div>
          <div class="form-row align-items-baseline" *ngIf="newWeaponMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [tableTitle]="'Create New Weapon'"
              [titlePosition]="'left'" [newEntityMode]="true" [tableData]="weaponsTableRows"
              [columnsData]="newWeaponCols" [isAdmin]="true" [typeaheadFunction]="broadTypeaheadSearch('weaponmodel', 'weapon')"
              (newEntityEvent)="handleNewEntity($event)" (cancelNewEntityEvent)="newWeaponMode = false"
              (saveChangesEvent)="commitNewWeapon($event)"></lib-table-editor>
          </div>
          <div class="form-row align-items-baseline" *ngIf="!newWeaponMode && !newWeaponCatMode">
            <lib-table-editor #weaponsTable class="table-editor" [rpp]="5" [tableMaxHeight]="tableMaxHeight"
              [rppOptions]="rppOptions" [filteredOptions]="filterNotifier" [titlePosition]="'left'"
              [notify]="weaponsNotifier" [tableData]="imageData.weapons" [tableTitle]="'Weapons'"
              [columnsData]="weaponsColumnData" [isAdmin]="true" (editDataEvent)="handleTableEditorOnChange($event)"
              (newEntityEvent)="handleNewEntity($event)" (filterEvent)="handleFilterWeapons($event)"
              (cancelNewRowEvent)="removeNewWeaponRow($event)" (deleteDataEvent)="commitWeaponLinkRemoval($event)"
              (saveChangesEvent)="commitWeaponLinkChanges($event)"></lib-table-editor>
          </div>

          <div class="form-row">
            <h3 class="fieldName">
              Contract items in this image
            </h3>
          </div>
          <div class="form-row" style="margin-top: -25px;">
            <div style="width:450px; height: 35px; margin-bottom: 45px; display: block;">
              <app-qm-search #qmManualSearch configIcon="fa-ellipsis-v" maxResults="5" (selectedOutput)="addQmToImageFile($event)" allDataDropdown="true" dropDown="true" (errorOutput)="qmSearchError($event)"></app-qm-search>
            </div>
          </div>
          <div class="form-row" style="margin-top: -40px;">
            <app-qmmanuals-display
            [columns]="['Item Name']" (removeAction)="removeQmLink($event)" [data]="mapQMLinkArray(true)" [isAdmin]="canEdit" [editable]="true">
            </app-qmmanuals-display>
        </div>

          <div class="form-row align-items-baseline" *ngIf="newRankCatMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [titlePosition]="'left'"
              [tableData]="newRankCatTableRows" [tableTitle]="'Create New Rank Category'"
              [columnsData]="rankCatColumnData" [isAdmin]="true" [newEntityMode]="true"
              (cancelNewEntityEvent)="newRankCatMode = false; rankCatMode = false"
              (saveChangesEvent)="commitNewRankCat($event)"></lib-table-editor>
          </div>
          <div class="form-row align-items-baseline" *ngIf="newRankMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [titlePosition]="'left'"
              [tableData]="newRankTableRows" [tableTitle]="'Create New Rank'" [columnsData]="rankColumnData"
              [isAdmin]="true" [newEntityMode]="true" (newEntityEvent)="handleNewEntity($event)"
              (cancelNewEntityEvent)="newRankMode = false" (saveChangesEvent)="commitNewRank($event)">
            </lib-table-editor>
          </div>

          <br/>
          <br/>
          <app-slant-button class="new-unit-btn" btnColor="gray" *ngIf="imageData.typeOfImageId !== ImageTypes.Ordnance_Returns" (click)="addImageIndividual()" btnIconClass="fa-plus">Add Individual</app-slant-button>
          <h3 *ngIf="imageData.typeOfImageId !== ImageTypes.Ordnance_Returns" style="font-size: 1rem; color: #5d5b5b;">
            Individuals</h3>
          <app-individuals-entry *ngIf="imageData.typeOfImageId !== ImageTypes.Ordnance_Returns && showIndividualEditor" [dropdownTypeDebounceTime]="appGlobalsSvc.dropdownTypeDebounceTime"
            [typeOfImageId]="imageData.typeOfImageId" [showIndividual]="showIndividualEditor" [data]="individualData"
            [editMode]="individualEditMode" [rankCats]="rankCatsData" [regiments]="regiments"
            [states]="statesData" [branches]="branchesOfService" [coLetters]="companyLetters"
            (doneAdding)="doneAddingIndividual($event)" (cancel)="cancelIndividualChanges()"
            (doneEditing)="doneEditingIndividual($event)" (delete)="commitImageIndividualRemoval($event)">
          </app-individuals-entry>
          <div *ngIf="individualsData$ | async; else individualsLoading" class="individualContainer" [ngClass]="{'mobile': isHandset}">
            <app-individuals-display *ngIf="imageData.typeOfImageId !== ImageTypes.Ordnance_Returns"
              [typeOfImageId]="imageData.typeOfImageId"
              [columns]="['Name','Rank', (this.imageData.typeOfImageId === ImageTypes['Letters & Diaries']) ? 'Author' : 'Rank in Photo', 'Regiment','State','Branch','Company','Notes']" [isAdmin]="canEdit"
              [data]="imageData.imageIndividuals" [totalRecords]="totalIndividualRecords" [editable]=true (editRow)="editIndividual($event)">
            </app-individuals-display>
          </div>
          <div class='sequenceTableContainer' title="Add records to related image sets through the gallery screen">
            <lib-table-editor [addDisabled]=true [titlePosition]="'left'" [notify]="relatedImagesNotifier"
              [rppOptions]="rppOptions" [rowType]="'Related Images'" [tableTitle]="'Related Images'"
              [tableMaxHeight]="tableMaxHeight" [notify]="sequenceNumberNotifier" [paginationOn]="true" [rpp]="10"
              [rowType]="'sequenceNumbers'" [tableData]="sequenceNumberRows" [isAdmin]="canEdit"
              [tableTitle]="'sequenceNumbers'" [columnsData]="sequenceNumberCols"
              (saveChangesEvent)="handleModifySequenceNumber($event)"
              (deleteDataEvent)="handleDeleteRelatedImageRecord($event)"
              (invalidDataEvent)="handleInvalidSequenceNumberData($event)">
            </lib-table-editor>
          </div>
          <div class='boundImageSetsContainer'>
            <lib-table-editor [addDisabled]=true [titlePosition]="'left'" [notify]="boundImageSetsNotifier"
              [rppOptions]="rppOptions" [rowType]="'Bound Image Sets'" [tableTitle]="'Bound Set Image Order'"
              [tableMaxHeight]="tableMaxHeight" [notify]="boundImageSetsNotifier" [paginationOn]="true" [rpp]="10"
              [rowType]="'boundImageSets'" [tableData]="boundImageSetTableRows" [isAdmin]="canEdit"
              [tableTitle]="'boundImageSets'" [columnsData]="boundImageSetsCols"
              (saveChangesEvent)="handleModifyBoundImageSets($event)" (invalidDataEvent)="badDataEntered()"
              (deleteDataEvent)="handleDeleteBoundImage($event)">
            </lib-table-editor>
          </div>
          <br>
          <div
            title="Check this box to toggle 'checked-out' status. Mark as 'checked-out' if more research is needed before this record is shown to subscribers."
            class="form-check form-check-inline">
            <label style="font-weight: bold;" class="form-check-label" for="checkedOutChkbox">Check out? </label>
            <input style="margin: 5px; height: 25px; width: 25px;" type="checkbox" name="checkedOutChkbox"
              id="checkedOutChkbox" (change)="markCheckOutStatusChanged()" class="form-check-input"
              [(ngModel)]="imageData.checkedOut">
            <label [hidden]="!imageData.checkedOut" for="checkedOutChkbox" style="font-size: 1em; max-width: fit-content;"
              class="badge badge-warning form-check-label">Subscribers will not be able to see this record.</label>
            <label [hidden]="imageData.checkedOut" for="checkedOutChkbox" style="font-size: 1em; max-width: 310px;"
              class="badge badge-info form-check-label">This record will be visible to subscribers.</label>
          </div>
          <br>
          <div title="Check this box to toggle 'fully-tagged' status. Mark as 'fully-tagged' if more research is ongoing on this record." class="form-check form-check-inline">
            <label style="font-weight: bold;" class="form-check-label" for="fullyTaggedChkbox">Fully tagged? </label>
            <input style="margin: 5px; height: 25px; width: 25px;" type="checkbox" name="fullyTaggedChkbox" id="fullyTaggedChkbox"
            class="form-check-input" [(ngModel)]="imageData.fullyTagged">
          </div>
        </div>
        <div *ngIf="imageData.typeOfImageId === ImageTypes.Ordnance_Returns">
          <div class="form-row align-items-baseline">
          <div class="col-1">
            <label class="fieldName" for="name">Name: </label>
          </div>
          <div class="col">
            <input type="text" #nameField autofocus class="editable form-control" placeholder="Name" id="nameField" [(ngModel)]="imageData.name" maxlength="100"
              name="name" #name="ngModel" required>

        <div *ngIf="!name.valid && !name.pristine" class="alert alert-danger">Name is required</div>
          </div>
          </div>
          <div class="form-row align-items-baseline">
            <div class="col-1"><label for="notes">Notes: </label></div>
            <div class="col"><textarea type="text" placeholder="Notes" class="editable form-control fieldName" id="notes" name="notes"
                [(ngModel)]="imageData.notes"></textarea></div>
          </div>
          <ng-container *ngTemplateOutlet="unitsEdit"></ng-container>
          <div class="form-row form-inline align-items-baseline" style="color: var(--RAred)">
            <lib-table-editor class="table-editor" [rppOptions]="rppOptions" [notify]="datesNotifier"
              [tableMaxHeight]="tableMaxHeight" [rpp]="5" [titlePosition]="'left'" [cancelNewRow]="true"
              [tableTitle]="'Dates'" [tableData]="datesTableRows" [columnsData]="datesColumnData" [isAdmin]="isAdmin"
              (deleteDataEvent)="commitDateRemoval($event)" (cancelNewRowEvent)="removeNewDateRow($event)"
              (saveChangesEvent)="commitDateChanges($event)" [paginationOn]="true"></lib-table-editor>
          </div>
          <div class="form-row align-items-baseline" *ngIf="!newArmyMode">
            <div class="col-lg-1 col-md-2"><label class="fieldName" for="army">Army: </label></div>
            <div class="col">
              <select class="form-control" name="army" id="army" (change)="checkNullArmy($event.target.value)"
                [(ngModel)]="imageData.armyId">
                <option [value]=null>No army selected</option>
                <option [value]="-1" style="font-weight: bold">+ Create New Regional Army</option>
                <option *ngFor="let a of armyData" [value]="a.uid">
                  {{ a.army?.armyName }} &ndash; {{ a.regionalName }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-row align-items-baseline">
              <div class="col-lg-1 col-md-2 me-2"><label class="fieldName" for="location">Location: </label></div>
              <div class="col-auto">
                <ng-container *ngTemplateOutlet="locationTypeahead"></ng-container>
              </div>
              <div class="col-lg-2 col-md-2"><label for="locationState">Location State: </label></div>
              <div class="col-auto">
                <select name="locationState" class="form-control" style="width: 180px;" id="locationState"
                  (change)="changeLocationState($event.target.value)" [(ngModel)]="imageData.locationStateId">
                  <option [ngValue]="">No state chosen</option>
                  <option *ngFor="let s of statesData" [value]="s.uid">{{ s.state_Name }}</option>
                </select>
              </div>
            </div>
            <div class="form-row align-items-baseline">
              <div class="col-lg-1 col-md-2"><label class="fieldName" for="regionalName">Region: </label></div>
              <div class="col inline">
                <ng-container *ngTemplateOutlet="regionTypeahead"></ng-container>
              </div>
            </div>
            <div class="form-row align-items-baseline form-row-checkboxes">
              <div class="custom-control custom-checkbox-me-2">
                <input type="checkbox" name="featured" [(ngModel)]="imageData.featured" class="custom-control-input"
                  id="featured">
                <label for="featured" class="custom-control-label">Featured</label>
              </div>
            </div>

            <ng-container *ngTemplateOutlet="keywordsDisplayer"></ng-container>


          <div class="form-row align-items-baseline" *ngIf="newWeaponCatMode" [hidden]="newWeaponMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [tableTitle]="'Create New Weapon Category'"
              [titlePosition]="'left'" [newEntityMode]="true" [tableData]="primaryWeaponsTableRows"
              [columnsData]="primaryWeaponsColumnData" [isAdmin]="true" (editDataEvent)="handleTableEditorOnChange($event)"
              (cancelNewEntityEvent)="newWeaponCatMode = false;" (saveChangesEvent)="commitNewWeaponCat($event)">
            </lib-table-editor>
          </div>

          <div class="form-row align-items-baseline" *ngIf="newWeaponMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [tableTitle]="'Create New Weapon'"
              [titlePosition]="'left'" [newEntityMode]="true" [tableData]="weaponsTableRows"
              [columnsData]="newWeaponCols" [isAdmin]="true" [typeaheadFunction]="broadTypeaheadSearch('weaponmomdel', 'weapon')"
              (newEntityEvent)="handleNewEntity($event)" (cancelNewEntityEvent)="newWeaponMode = false"
              (saveChangesEvent)="commitNewWeapon($event)"></lib-table-editor>
          </div>

          <div class="form-row align-items-baseline" *ngIf="!newWeaponMode && !newWeaponCatMode">
            <lib-table-editor #weaponsTable class="table-editor" [rpp]="5" [tableMaxHeight]="tableMaxHeight"
              [rppOptions]="rppOptions" [filteredOptions]="filterNotifier" [titlePosition]="'left'"
              [notify]="weaponsNotifier" [tableData]="imageData.weapons" [tableTitle]="'Weapons'"
              [columnsData]="weaponsColumnData" [isAdmin]="true" (editDataEvent)="handleTableEditorOnChange($event)"
              (newEntityEvent)="handleNewEntity($event)" (filterEvent)="handleFilterWeapons($event)"
              (cancelNewRowEvent)="removeNewWeaponRow($event)" (deleteDataEvent)="commitWeaponLinkRemoval($event)"
              (saveChangesEvent)="commitWeaponLinkChanges($event)"></lib-table-editor>
          </div>

          <div class="form-row align-items-baseline" *ngIf="newRankCatMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [titlePosition]="'left'"
              [tableData]="newRankCatTableRows" [tableTitle]="'Create New Rank Category'"
              [columnsData]="rankCatColumnData" [isAdmin]="true" [newEntityMode]="true"
              (cancelNewEntityEvent)="newRankCatMode = false; rankCatMode = false"
              (saveChangesEvent)="commitNewRankCat($event)"></lib-table-editor>
          </div>

          <div class="form-row align-items-baseline" *ngIf="newRankMode">
            <lib-table-editor class="table-editor newEntityTableEditor" [titlePosition]="'left'"
              [tableData]="newRankTableRows" [tableTitle]="'Create New Rank'" [columnsData]="rankColumnData"
              [isAdmin]="true" [newEntityMode]="true" (newEntityEvent)="handleNewEntity($event)"
              (cancelNewEntityEvent)="newRankMode = false" (saveChangesEvent)="commitNewRank($event)">
            </lib-table-editor>
          </div>

          <!-- <div class='form-row'>
            <h3 style="font-size: 1rem; color: #777;">
              Contract items in this image
            </h3>
          </div> -->

          <div class='form-row' style='margin-top: -25px;'>
            <div style='width:280px; height: 35px; margin-bottom: 15px; display: block;'>
              <!-- <app-qmmanuals-autocomplete (resultItemClickEvent)='addQmToImageFile($event)'></app-qmmanuals-autocomplete> -->
            </div>
          </div>
          <div class='form-row' style='margin-top: -40px;'>
            <app-qmmanuals-display
            [columns]="['Item Name']" (removeAction)='removeQmLink($event)' [data]="mapQMLinkArray(true)" [isAdmin]="canEdit" [editable]="true">
            </app-qmmanuals-display>
          </div>
          <div class='boundImageSetsContainer'>
            <lib-table-editor [addDisabled]=true [titlePosition]="'left'" [notify]="boundImageSetsNotifier"
              [rppOptions]="rppOptions" [rowType]="'Bound Image Sets'" [tableTitle]="'Bound Set Image Order'"
              [tableMaxHeight]="tableMaxHeight" [notify]="boundImageSetsNotifier" [paginationOn]="true" [rpp]="10"
              [rowType]="'boundImageSets'" [tableData]="boundImageSetTableRows" [isAdmin]="canEdit"
              [tableTitle]="'boundImageSets'" [columnsData]="boundImageSetsCols"
              (saveChangesEvent)="handleModifyBoundImageSets($event)" (invalidDataEvent)="badDataEntered()"
              (deleteDataEvent)="handleDeleteBoundImage($event)">
            </lib-table-editor>
          </div>
          <div title="Check this box to toggle 'checked-out' status. Mark as 'checked-out' if more research is needed before this record is shown to subscribers." class="form-check form-check-inline">
            <label style="font-weight: bold;" class="form-check-label" for="checkedOutChkbox">Check out? </label>
            <input style="margin: 5px; height: 25px; width: 25px;" type="checkbox" name="checkedOutChkbox" id="checkedOutChkbox" (change)="markCheckOutStatusChanged()"
            class="form-check-input" [(ngModel)]="imageData.checkedOut">
            <label [hidden]="!imageData.checkedOut" for="checkedOutChkbox" style="font-size: 1em;" class="badge badge-warning form-check-label">Subscribers will not be able to see this record.</label>
            <label [hidden]="imageData.checkedOut" for="checkedOutChkbox" style="font-size: 1em; max-width: 310px;" class="badge badge-info form-check-label">This record will be visible to subscribers.</label>
          </div>
          <div title="Check this box to toggle 'fully-tagged' status. Mark as 'fully-tagged' if more research is ongoing on this record." class="form-check form-check-inline">
            <label style="font-weight: bold;" class="form-check-label" for="fullyTaggedChkbox">Fully tagged? </label>
            <input style="margin: 5px; height: 25px; width: 25px;" type="checkbox" name="fullyTaggedChkbox" id="fullyTaggedChkbox"
            class="form-check-input" [(ngModel)]="imageData.fullyTagged">
          </div>
        </div>
      </form>

      <!-- ....END EDIT MODE AREA.... -->

      <hr>
      <div class="row align-items-baseline recordInfo" [ngClass]="{'mobile': isHandset}">
        <div class="col-auto">Source: {{ imageData.source?.source }}</div>
        <div class="col-auto" *ngIf="!callNoIsUrl; else clickableCallNo">Call #: <span [innerHtml]="imageData.callNo | embolden : librarySearchText : 0 : searchHighlightStyle"></span></div>
        <ng-template #clickableCallNo>
          <div class="col-auto">
            <a [href]="imageData?.callNo" target="_blank" rel="noopener noreferrer" title="Click to visit this record's Call Number site.">
              <span [innerHtml]="imageData.callNo | embolden : librarySearchText : 0 : searchHighlightStyle"></span>
            </a>
          </div>
        </ng-template>
      </div>
      <div class="row align-items-baseline recordInfo" [ngClass]="{'mobile': isHandset}">
        <div class="col-auto">
          {{ imageData.sourceCallNumber?.callNumberL1 }}
        </div>
        <div class="col-auto">
          {{ imageData.sourceCallNumber?.callNumberL2 }}
        </div>
        <div class="col-auto">
          {{ imageData.sourceCallNumber?.callNumberL3 }}
        </div>
        <div class="col-auto">
          {{ imageData.sourceCallNumber?.callNumberL4 }}
        </div>
      </div>
      <div *ngIf="canEdit" class="row align-items-baseline recordInfo" [ngClass]="{'mobile': isHandset}">
        <div class="col-auto">Id: {{ imageData.uid }}</div>
        <div class="col-auto" *ngIf="isAdmin">Guid: {{ imageData.guid }}</div>
        <div class="col-auto" *ngIf="isAdmin">
          <button class="btn btn-sm btn-link" (click)="sbCmpMsg.recordHistoryEmitter.emit(imageData.guid)">
            <i class="fal fa-history me-1"></i>
            Record history
          </button>
        </div>
        <div class="col-auto">
          {{ imageData.checkedOut ? 'Checked Out' : 'Checked In' }}
          <i class="fas" [ngClass]="imageData.checkedOut ? 'fa-eye-slash' : 'fa-eye'"></i>
        </div>
        <div class="col-auto">Batch #: {{ imageData.batchNo }}</div>
        <div class="col-auto">Initial Upload: {{ imageData.initialUpload | date: 'long' }}</div>
        <div class="col-auto" style="font-weight: bold;" [hidden]="!imageData.featured">Featured <i class="fal fa-star ms-1"></i></div>
      </div>
      <div *ngIf="canEdit" class="row align-items-baseline recordInfo" [ngClass]="{'mobile': isHandset}">
        <app-edit-history-display [columns]="['Whodunit', 'Date/Time', 'Process Used', 'Action Taken']"
          [edits]="imageData.editHistory" [isAdmin]="canEdit"></app-edit-history-display>
      </div>
      <br><br>
    </div>
  </div> 
  <div class="imageCarouselContainerMAIN">
    <app-image-carousel-holder  *ngIf="loaded"
      [expandMode]="thumbnailGridMode"
      [rsvImageModels]="relevantRelatedImageSetsForCurrentRecord"
      [imageCollection]="getHistoryThumbnails() | async" 
      [relatedSetCollections]="recordSets"
      (changePageEmitter)="navigateToLibrary()"
      (recordSelected)='simpleIndex = true; switchRecord($event)'>
    </app-image-carousel-holder>
  </div>
</div>
<br>

<div class="helpDiv">
  <button type="button" class="btn helpButton" [matTooltip]="'Suggest Edit or Correction'" (click)="openSuggestContent()">
    <i class="fal fa-xl fa-comment-edit"></i>
  </button>
</div>
</ng-container>

<ng-template #crawlerDisplay>
  <div *ngIf="this.loaded" style="background-color: whitesmoke; color: whitesmoke;">
    <h1>{{imageData.name}}</h1>
    <p *ngFor="let battle of imageData.battleLinks">{{battle.battle?.name}}</p>
    <p>{{imageData.location}}</p>
    <p>{{imageData.notes}}</p>
    <p>{{imageData.transcription}}</p>
    <div>
      <p *ngFor="let unit of imageData.units">{{unit.corpsDisplay}} - {{unit.regimentNo?.regimentDisplayText()}} - {{unit.state?.abbreviation}} - {{unit.branch?.branchName}} - {{unit.companyLetters}}</p>
    </div>
    <div>
      <p *ngFor="let individual of imageData.imageIndividuals">{{individual.firstName}} {{individual.lastName}} - {{individual.rank?.rankCategory?.rankCategory}} {{individual.rank?.rankName}} - {{individual.regimentNo?.regimentDisplayText()}} - {{individual.companyLetters}} - {{individual.notes}}</p>
    </div>
    <div>
      <p *ngFor="let item of mapQMLinkArray()">{{item.itemName}}</p>
    </div>
    <div>
      <p *ngFor="let weapon of imageData.weapons">{{weapon.weapon?.secondaryWeapon}} - {{weapon.weapon?.primaryWeapon?.weapon_Category}}</p>
    </div>
  </div>
</ng-template>